import { DrugListResult, DrugPricingRequest, DrugPricingResponse } from "../types";
import { request } from "./request";

export async function priceDrug(drugPriceRequest: DrugPricingRequest): Promise<DrugPricingResponse> {
  return await request({
    url: "/drug/price/list",
    method: "POST",
    data: { ...drugPriceRequest },
  });
}

export async function listDrugs(search: string): Promise<DrugListResult> {
  return await request({
    url: "/drug/list",
    method: "POST",
    data: {
      search: search,
    },
  });
}
